// Single source of truth for a user's Optimal Blue connection state.
//
// Price-readiness requires BOTH an OB user id AND a business channel — a linked
// user with a null channel is `partial`, NOT connected. Encoding this once (and
// using it on every surface) prevents the class of bug where "has OB user id" was
// treated as "price-ready" while Artemis pricing was silently blocked.

export type ObConnectionState = 'connected' | 'partial' | 'not_connected';

// A price-ready business channel is a positive-integer id (mirrors the backend
// norm) — "0", blanks, and whitespace are NOT valid and must read as `partial`.
function isValidChannel(channel?: string | null): boolean {
  return /^[1-9][0-9]*$/.test((channel ?? '').trim());
}

export function obConnectionState(
  optimalBlueUserId?: string | null,
  optimalBlueBusinessChannelId?: string | null
): ObConnectionState {
  if (optimalBlueUserId && isValidChannel(optimalBlueBusinessChannelId)) {
    return 'connected';
  }
  if (optimalBlueUserId) {
    return 'partial';
  }
  return 'not_connected';
}
